import angular from "angular";

const storageServiceFactory = function StorageServiceFactory() {
      "ngInject";
      return {
        setLocalStorage: function(name, value) {
          if (typeof(Storage) !== "undefined") {
            localStorage[name] = value;
          }
        },
        getLocalStorage: function(name) {
          if (typeof(Storage) !== "undefined") {
            return localStorage[name];
          }
          return false;
        },
        clearLocalStorage: function(name) {
          delete localStorage[name];          
        },
        setLocalStorageObject: function(name, value) {
          if (typeof(Storage) !== "undefined") {
            localStorage[name] = angular.toJson(value);
          }
        },
        getLocalStorageObject: function(name) {
          if (typeof(Storage) !== "undefined") {
            return angular.fromJson(localStorage[name]);
          }
          return false;
        }
      };
    }

export default storageServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/storage.factory.js
 **/